export default "__VITE_ASSET__uqVf04ji__"